
import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate, Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import moment from "moment";
import * as Config from "../constants/Config";
import OTPInput from "otp-input-react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import { SettingsSystemDaydreamSharp } from "@mui/icons-material";

let { lambda, country, appname } = window.app;

const AdminLogin = () => {
  const [pwd, setPwd] = useState('');
  // const [emailId, setEmailId] = useState("")
  const [email, setEmail] = useState("");
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [config, setConfig] = useState({});
  const navigate = useNavigate();
  const [activeLoad, setActiveLoad] = useState("");

const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [BtnLoader, setBtnLoader] = useState('');
  const [otpclass, setOtpClass] = useState(false);
  const [otp, setShowOtp] = useState(false)

  const [signinOtp, setSigninOtp] = useState("");
  const [visibility, setVisibility] = useState({ newpwd:false,cnfrmpwd:false,showpassword:false });
  const [componentType,setComponentType]=useState("");
  const [resendActive, setResendActive] = useState(false);
  const { userData, setUserData, activeMenuObj, setActiveMenuObj, GetClientDataContext, activeMenuId, setActiveMenuId } = useContext(contentContext)

  // useEffect(() => {
  //     websitedefaults();
  // }, []);
  // const websitedefaults = async () => {
  //     try {
  //         console.log(tmdbApi);
  //         const response = await tmdbApi.websitedefaults();

  //         console.log(response);
  //     } catch {
  //         console.log("error");
  //     }
  // };
  useEffect(() => {
 
    if (window.site === undefined) {
        setTimeout(() => {
            if (window.site && window.site.common && window.site.common.imageCloudfront) {
                setImg(window.site.common.imageCloudfront)
            }
        }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
        setImg(window.site.common.imageCloudfront)
    }


}, [window.site]);

  //  useEffect(() => {
  //      if ((localStorage.getItem("clientid"))) {
  //          GetUserDataSignIn();
  //      }
  //  }, []);
  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    }

  }, []);
  // const handleKeypress = (e) => {
  //   //it triggers by pressing the enter key

  //   if ((e.key === "Enter")) {
  //     setTimeout(function () {
  //       handleSignIn();
  //       console.log("called");
  //     }, 1000);
  //   }
  // };

  const handleSignIn = (e) => {
   
    console.log("called1");
    if (email === "" && pwd === "") {
      setError("Please enter email and password");
      setTimeout(function () { setError("") }, 3000);
    }
    else if (email === "") {
      setError("Please enter email");
      setTimeout(function () { setError("") }, 3000);
    }
    else if (pwd === "") {
      setError("Please enter password");
      setTimeout(function () { setError("") }, 3000);
    }
    if (email && pwd) {
      setBtnLoader("loginpwd")
      loginPwd();
    }
  }

   const loginPwd = async () => {
   setActiveLoad("loginpwd") 
       try {

           const response = await tmdbApi.UserSignin({
               "emailid": email,
               "password": pwd,
              //  "useragent": JSON.parse(localStorage.getItem("loc"))
           });
           console.log(response);
           if (response?.statusCode===200 && response?.result === "Invalid email or password") {
            setActiveLoad("")
               setError(response?.result);
               setTimeout(function () { setError("") }, 3000);
               setBtnLoader("")
           } else if (response?.result === "Session Already Exists") {
              //  signoutsession()
               setShowSessionPopup(true)
               setBtnLoader("")
               setActiveLoad("")
           } else {
               localStorage.setItem("token", response?.result.token);
               localStorage.setItem("userId", response?.result.userid);
              //  localStorage.setItem('login_type', 'admin');
              setActiveLoad("")
              //  GetUserDataSignIn();
              GetClientDataContext();
               localStorage.setItem("loginTime",moment().format('DD-MMM-YYYY HH:mm:ss'))
               navigate("/dashboard");
           }


       } catch {
           console.log("error");
           setBtnLoader("")
           setError("Invalid email or password");
           setTimeout(function () { setError("") }, 3000);
       }
   };

  // console.log('userDatauserDatauserData', userData)
  const GetUserDataSignIn = async () => {
    try {

      const response = await tmdbApi.getClientData({});

      if (response?.statusCode === 200) {

        setUserData(response?.result?.[0]);
        localStorage.setItem("ClientName", response?.result?.[0]?.name)
        localStorage.setItem("ClientType", response?.result?.[0]?.type)
        let userArr = response?.result?.[0]?.permissions
        const EMAILID = response?.result?.[0]?.emailid
        console.log('user email', EMAILID)
        window.clarity("set", "orasi_user_email", EMAILID)
        // Clarity.addTag('Orasi User Email', EMAILID);
        const obj = userArr.reduce((acc, item) => {
          if (item.submenus) acc[item.menu] = false;
          return acc;
        }, {});
        // console.log('objjjjjjjj--->',obj)

        if (!(localStorage.getItem("check"))) {
          let k = response?.result?.[0]

          let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
          let filterdList = permissionList.filter((item) => item.display===true)
          const data = filterdList?.filter((value) => value?.menu === "Dashboard")
          let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()

          navigate("/" + id);
          navigate("/users");


          setActiveMenuId(data && data[0] && data[0].menuid)
          console.log("activeMenuid------->", data)
        }

        // setActiveMenuObj(obj)
        setBtnLoader("")
        // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
      }
    } catch {
      setBtnLoader("")
      console.log("error");
    }
  };

  const forgotPassword = async () => {
    try {
      setBtnLoader("forgotpwd")
      const response = await tmdbApi.ForgotPassword({
        "emailId": email
      });
      console.log(response);
      if (response?.statusCode===200 && response?.result === "mail sent successfully") {
        setSuccess(true);
      } else if (response?.statusCode===200 && response?.result === "Email does not exists") {
        setError("Email Does Not Exists . Please enter valid email");
        setTimeout(function () { setError("") }, 3000);
      } else {
        setError("Please enter email Id");
        setTimeout(function () { setError("") }, 3000);
      }
      setBtnLoader("")
    } catch {
      console.log("error");
      setBtnLoader("")
      setError("Please enter email id");
      setTimeout(function () { setError("") }, 3000);
    }
  };
console.log(email,'emailllll')
const emailValidation = (e)=> {
  let flag = true;
  const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
  if (regEx.test(email)) {
      setError("");

  } else if (!regEx.test(email) && email !== "") {
      setError("Email is not valid");
      setTimeout(function () { setError("")}, 3000);
      flag = false;
  }
  if (email === "") {
      setError("Please enter email");
      setTimeout(function () { setError("")}, 3000);
      flag = false;
  }
  return flag

}


  //  const signin = async () => {
  //     try {
  //         const response = await tmdbApi.signin({
  //             "emailid": email,
  //             "logintype": "otp"
  //         });
  //         if(response?.result==="Client not found"){
  //             setError("Client not Found. Please SignUp ");
  //         } else if(response.result === "PENDING VERIFICATION"){
  //             setError("Please Complete SignUp Process");
  //         }else{
  //             console.log(response);
  //         }
  //         // console.log()

  //         // if (response.statusCode === 200) {
  //     //     if (response.result === "PENDING VERIFICATION") {
  //     //         setError("Please Complete SignUp Process");
  //     //         setTimeout(function () { navigate("/signup") }, 3000);

  //     //     } else if (response.result === "PENDING TERMS") {
  //     //         setError("Please Check And Accept Terms ");
  //     //         setTimeout(function () { navigate("./terms/"+email) }, 3000);

  //     //     } else if (response.result === "PENDING REGISTRATION") {
  //     //         setError("Please Complete SignUp Process");
  //     //         setTimeout(function () { navigate("/signup") }, 3000);

  //     //     } else if (response.result === "user not found") {
  //     //         setError("User not Found. Please SignUp ");
  //     //         // setTimeout(function () { setError("")}, 3000);
  //     //     } else if (response.result === "PENDING APPROVAL") {
  //     //         setError("Please Wait For Admin Approval");
  //     //         setTimeout(function () { navigate("/message") }, 3000);
  //     //     }
  //     //     else if (response.result === "REJECT") {
  //     //         localStorage.setItem("rejected", response.result);
  //     //         handleShowPopup("Your account has not been approved.")

  //     //     }  else if (response.result === "Invalid password") {
  //     //         setError("Invalid password");
  //     //     } else if (response.result === "Invalid email") {
  //     //         setError("Invalid email");
  //     //     }else if (response.result === "Client not found") {
  //     //         setError("User not Found. Please SignUp ");
  //     //     }else if (response.result === "INACTIVE") {
  //     //         localStorage.setItem("inactive", response.result);
  //     //         handleShowPopup("Your account has been deactivated.")
  //     //         // setTimeout(function () { navigate("/signup") }, 3000);
  //     //     }else if (response.result === "Session Already Exists") {
  //     //         // signoutsession()
  //     //        setShowSessionPopup(true)
  //     //     }else if (response.result === "ACTIVE" || response.result === "Email Sent Successfully") {
  //     //         localStorage.setItem("loginuser", email);
  //     //         localStorage.setItem("login", "setlogin");
  //     //         let currentDate = new Date().toJSON();
  //     //         localStorage.setItem("currentSessionClientTime", currentDate);
  //     //         setWelcomeMsg(true)

  //     //         navigate("/loginotp");
  //     //     }
  //     //     else {
  //     //         setError("Invalid Details");

  //     //     }
  //     // setActiveLoad("")
  //     } catch {
  //         // setActiveLoad("")
  //         // navigate("/loginotp");
  //         console.log("error");
  //     }
  // };

  const signOtp = async () => {

    try {
      //   setActiveLoad("loginOtp")
      const response = await tmdbApi.signOtp({
        "emailId": email,
        "logintype": "otp",
        "otp": Number(signinOtp),
        // "useragent" : locData?.headers !== undefined ? locData?.headers : {}
      });
      if (response.result.res === "password not set") {
        localStorage.setItem("clientid", response.result.clientid);
        navigate("/generatepwd/" + response.result.clientid);
      } else if (response?.result === "Invalid otp entered") {
        setOtpClass(true); // Handle invalid OTP
      } else if (response.result.token) {
        console.log("came");
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        navigate("/dashboard");
        GetClientDataContext()
      }
      setActiveLoad("");
      console.log(response);

      //   if (response.result.res === "password not set") {
      //     localStorage.setItem("clientid", response.result.clientid);
      //     navigate("/generatepassword/?id="+response.result.clientid);
      //   }else if(localStorage.getItem("check") && response.statusCode === 200){
      //     console.log("came");
      //     localStorage.setItem("token", response.result.token);
      //     localStorage.setItem("clientid", response.result.clientid);
      //     localStorage.setItem("login", "setlogin");
      //     let currentDate = new Date().toJSON();
      //     localStorage.setItem("currentSessionClientTime", currentDate);
      //     GetClientDataFunction();
      //     navigate("/moreinfo/" + localStorage.getItem("check"));
      // } else if (response.result.token) {
      //     console.log("came");
      //     localStorage.setItem("token", response.result.token);
      //     localStorage.setItem("clientid", response.result.clientid);
      //     let currentDate = new Date().toJSON();
      //     localStorage.setItem("currentSessionClientTime", currentDate);
      //     navigate("/content");
      //   } else {
      //     // setError(response.result);
      //     // setTimeout(function () { setError("") }, 3000);
      //     // var element = document.getElementById("otp");
      //     // element.classList.add("invalid");
      //     // setTimeout(function () { 
      //     // element.classList.remove("invalid");
      //     // setOtp("")
      //     // one.current.value="";
      //     // two.current.value="";
      //     // three.current.value="";
      //     // four.current.value="";
      //     // five.current.value="";
      //     //  }, 3000);
      //     setOtpClass(true)
      //     setActiveLoad("")
      //   }
    } catch {
      //   setActiveLoad("")
      console.log("error");
      // var element = document.getElementById("otp");
      // element.classList.add("invalid");

      //   setTimeout(function () { 
      //     element.classList.remove("invalid");
      //   setOtp("")
      // }, 3000);
    }
  };



  const handleForgot = (e) => {
    if (BtnLoader==="") {
      forgotPassword();
    }
  }

  // function onConfirm() {
  //   setSuccess(false);
  // };

  // const handleShowSessionPopup = () => {
  //   setShowSessionPopup(true)
  // }
  const onCancel = () => {
    setShowSessionPopup(false)
    setBtnLoader("")
  }
  const signoutsession = async () => {
    try {
      setBtnLoader("sessionLoad")
      const response = await tmdbApi.SignOutUser({ emailid: email });
      console.log(response);
      if (response?.result==="Success") {
        loginPwd()
        // SigninPwd()
      } else {
        setError("Invalid Details");
        setBtnLoader("")
      }
    } catch {
      setBtnLoader("")
      console.log("error");
    }
  }

  // const handleMessage = (e) => {
  //   setError("");
  // }


  const SigninPwd = async () => {
    setActiveLoad("loginpwd") 
    try {

      const response = await tmdbApi.signin({
        "emailId": email,
        "logintype": "password",
        "password": pwd,

      });
      console.log(response);
      console.log(response.result);
      if (response.result === "Invalid email or password") {
        setError(response.result);
        //setTimeout(function () { setError("") }, 3000);
      } else if (response.result === "Please log in using OTP and set a password") {
        setError("Please log in using OTP and set a password");

        // } else if (response.result === "REJECT") {
        //     // localStorage.setItem("rejected", response.result);
        //     handleShowPopup("Your account has not been approved.")

        // } else if (response.result === "INACTIVE") {
        //     // localStorage.setItem("inactive", response.result);
        //     handleShowPopup("Your account has been deactivated.")
        //     // setTimeout(function () { navigate("/signup") }, 3000);
      }
      else if (response.result === "Session Already Exists") {
        // signoutsession()
        //    setShowSessionPopup(true)
      }
      else if (response.result === "PENDING VERIFICATION") {
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/signup") }, 3000);

      } else if (response.result === "PENDING TERMS") {
        setError("Please Check And Accept Terms ");
        // setTimeout(function () { navigate("./terms/"+email) }, 3000);

      } else if (response.result === "PENDING REGISTRATION") {
        setError("Please Complete SignUp Process");
        setTimeout(function () { navigate("/signup") }, 3000);

      } else if (response.result === "user not found") {
        setError("User not Found. Please SignUp ");
        setTimeout(function () { setError("") }, 3000);
      } else if (response.result === "PENDING APPROVAL") {
        setError("Please Wait For Admin Approval");
        // setTimeout(function () { navigate("/message") }, 3000);
      } else if (response.result === "Invalid password") {
        setError("Invalid password");
      } else if (response.result === "Client not found") {
        setError("Client not Found. Please SignUp ");
        setTimeout(() => {
          setError("");  // Clears the error after 3 seconds
        }, 3000);
      } else if (response.result === "Invalid email") {
        setError("Invalid email");
      } else if (response.result && response.result.token) {
        // console.log('elseeeeeee block of signin')
        localStorage.setItem("token", response.result.token);
        localStorage.setItem("clientid", response.result.clientid);
        localStorage.setItem("login", "setlogin");
        // console.log('response.result.clientid', response.result.clientid)
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        // setWelcomeMsg(true)
        // GetClientDataFunction();
        GetClientDataContext();
        setActiveLoad("") 
        navigate("/clients");
      }
      else {
        setError("Invalid Details");

      }
      // setActiveLoad("")
    } catch {
      // setActiveLoad("")
      console.log("error");
    }
  };
 

  const handleClick = async (data) => {
      
    if (data === "otp") {
      const validate = emailValidation();
      console.log("otpppppppppppppppppppppppppppppppppppppppppppppppp");
  
      if (validate) {
        try {
          const response = await tmdbApi.signin({
            emailId: email,
            logintype: "otp",
          });
  
          if (response?.result === "Client not found") {
            setError("Client not Found. Please SignUp ");
          } else if (response.result === "PENDING VERIFICATION") {
            setError("Please Complete SignUp Process");
          } else {
            console.log(response);
            setComponentType(data);
            // setShowOtp(true); // Move inside successful response handling
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    } else if(data==="recoverotp"){
      const validation = emailValidation();
if(validation){
setComponentType(data);
}
    }else{
        setComponentType(data);
      }
  
    console.log("componentTypeeeeeeeeeeeeeeeeeee", data);
  };
  const handleChange = (otp) => {
    setSigninOtp(otp)
    setOtpClass(false);
  }
  const handleResendOtp = async () => {
    setResendActive(true)
    setTimeout(function () {
      setResendActive(false)
    }, 3000)
    // setOtpClass(true)
    try {
      //   console.log(tmdbApi);
      const response = await tmdbApi.resendMailSignin({
        "emailId": email,

      });
      // setResendActive(false)
      console.log(response);
    } catch {
      setResendActive(false)

      console.log("error");
    }
  };
  console.log("emaillllllllllllllllllllllllllll",email)
  const handleClose=()=>{
    if(componentType==="frgtpwd"){
      setVisibility({...visibility,showpassword:false})
      setComponentType("password")
    }else if(componentType==="recoverotp"){
  setComponentType("frgtpwd")
    }else if(componentType==="verify"){
      setComponentType("recoverotp")
      
    }else{
      setComponentType("")
      setVisibility({...visibility,newpwd:false,cnfrmpwd:false})
    }
     
  }
  const handleLogin=(type) =>{
 
        handleSignIn()
    
  }

  return (
    <>
      <Modal className="access-denied" show={showSessionPopup} id="session-modal">
        <div className="modal-body enquiry-form">
          <div className="container">
            <button className="close-btn" id="close-session-modal" onClick={onCancel}>
              <span className="material-icons">close</span>
            </button>
            <span className="material-icons access-denied-icon" id="session-warning-icon">
              web_asset_off
            </span>
            <h3 id="session-modal-title">Multiple Sessions Found</h3>
            <p id="session-modal-text">
              Another session is running in another browser. Do you want to terminate that session?
            </p>
            <div className="popup-footer">
              <button 
                className="fill_btn yellow-gradient" 
                id="terminate-session-btn"
                onClick={signoutsession}
              >
                {BtnLoader === "sessionLoad" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />
                ) : null}
                Yes
              </button>
              <button className="fill_btn" id="cancel-session-btn" onClick={onCancel}>No</button>
            </div>
          </div>
        </div>
      </Modal>
  
      {success && (
        <div className="toast show animate__animated animate__bounce spotsaver-login-toast" id="success-toast">
          <div className="toast-header">
            <p className="me-auto">
              <span className="toast-icon">
                <span className="material-icons">check_circle</span>
              </span>
              Reset password link sent to your email id
            </p>
            <button type="button" className="btn-close" id="close-success-toast" data-bs-dismiss="toast" onClick={() => setSuccess(false)}></button>
          </div>
        </div>
      )}
  
      <div className="signin-wrapper" id="signin-wrapper">
        <div className="logo_section" id="logo-section">
          <img src={`${image}${appname}/images/web/logo-dark.png`} className="logo" id="signin-logo" />
        </div>
        <div className="signin-body" id="signin-body">
          <div className="signin-graphic" id="signin-graphic">
            <img src={`${image}${appname}/images/web/Admin-Login-Graphic.svg`} id="signin-graphic-img"/>
            <h3 id="signin-graphic-title">Welcome Administrator!
            </h3>
            <p id="signin-graphic-text">Log in to access and manage your admin dashboard</p>
          </div>
          <div className="signin-section emaillogin admin-login" id="email-login-section">
            <h1 className="bold-heading" id="login-title" style={{ fontSize: "25px" }}>
            Admin Login
            </h1>
            <p id="login-subtext">Enter Login Credentials</p>
  
        


            <div className="input_group_wrapper">
    <label className="form_label">Email</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span class="material-symbols-outlined">mail</span>
        </div>
        <input type="text" className="form-control" id="email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
    </div>
</div>

            
            <div className="input_group_wrapper mt-3">
    <label className="form_label">Password</label>
    <div className="input_group">
        <div className="icon_wrapper">
        <span class="material-symbols-outlined">lock</span>
        </div>
        <input  
                className="form-control padding-right"
               type={visibility?.showpassword ? "text" : "password"} 
                id="password-input" 
                onChange={(e) => setPwd(e.target.value)} 
                placeholder="Password" 
                />


        <span  id="togglePasswordVisibility" onClick={() => setVisibility((prev) => ({ showpassword: !prev.showpassword }))} className="material-symbols-outlined lock-style"> {visibility.showpassword ? "visibility_off" : "visibility"}</span>
        </div>
    
</div>
            <p className="signup-prompt mt-4 d-flex">
              <input type="checkbox" className="me-2" id="remember-password-checkbox" />
              Remember Password
              <a className="ms-auto forgot-style" id="forgot-password-link" onClick={handleForgot}>
                {BtnLoader === "forgotpwd" ? (
                  <img src={`${image}${appname}/images/web/rotate_right_blue.svg`} className="loading-icon" />
                ) : null}
                Forgot Password?
              </a>
            </p>
  
            {error && <span className="errormsg-floating" id="error-message" style={{ fontWeight: 'bold', color: 'red' }}>{error}</span>}
  
            <div className="signin-footer mt-3">
              <button className="fill-btn" id="login-button" onClick={() => handleLogin("password")} disabled={activeLoad === "loginpwd"}>
                {activeLoad === "loginpwd" ? (
                  <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />
                ) : null}
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <footer className="login_footer" id="login-footer">
        <div className="container-fluid">
          <p className="footer-para" id="footer-text">© 2026 SpotSaver. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
  
};

export default AdminLogin;
